import { Component, OnInit } from '@angular/core'
import { Input } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { WikipediaPageview } from 'src/app/models/period-aggregate-amounts.model'
import {
  getWikipediaPageviews,
  getLoading,
} from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByWikipediaPageviews,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-wikipedia-pageview',
    templateUrl: './aggregated-amounts-wikipedia-pageview.component.html',
    styleUrls: ['./aggregated-amounts-wikipedia-pageview.component.scss'],
    standalone: false
})
export class AggregatedAmountsWikipediaPageviewComponent implements OnInit {
  wikipediaPageView$: Observable<WikipediaPageview[]>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  @Input() wikiUrl: string

  ngOnInit() {
    this.wikipediaPageView$ = this.store.select(getWikipediaPageviews)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByWikipediaPageviews)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
